import React, { createContext, useContext, useState } from 'react';

// Initial registration form state
const initialFormData = {
  personal: {
    firstName: '',
    lastName: '',
    phoneNumber: ''
  },
  professional: {
    specializations: [],
    experienceYears: '',
    bio: '',
    consultationFee: ''
  },
  availability: {
    timezone: 'Asia/Kolkata', // Default IST
    schedule: {}
  }
};

// Initial validation state
const initialValidState = {
  personal: false,
  professional: false,
  availability: false
};

// Create context
const RegistrationContext = createContext({
  currentStep: 0,
  token: null,
  email: '',
  formData: initialFormData,
  isValid: initialValidState,
  setCurrentStep: () => {},
  setToken: () => {},
  setEmail: () => {},
  updateFormData: () => {},
  setStepValidity: () => {}
});

// Provider component
export const RegistrationProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [token, setToken] = useState(null);
  const [email, setEmail] = useState('');
  const [formData, setFormData] = useState(initialFormData);
  const [isValid, setIsValid] = useState(initialValidState);
  
  // Update form data for a specific section
  const updateFormData = (section, data) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        ...data
      }
    }));
  };
  
  // Set validity for a step
  const setStepValidity = (step, valid) => {
    setIsValid(prev => ({
      ...prev,
      [step]: valid
    }));
  };
  
  return (
    <RegistrationContext.Provider value={{
      currentStep,
      token,
      email,
      formData,
      isValid,
      setCurrentStep,
      setToken,
      setEmail,
      updateFormData,
      setStepValidity
    }}>
      {children}
    </RegistrationContext.Provider>
  );
};

// Custom hook for using this context
export const useRegistration = () => useContext(RegistrationContext);

export default RegistrationContext;
